import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import GranteeProfileInfo from '../../../../widgets/granteeProfileInfo/GranteeProfileInfo'
import { getGranteeForStaffSubProject } from '../../../../redux/actions/granteeForStaff'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'

export default function granteeForStaffSubproject() {
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  // const proposalId = '1D3684B7-4D9D-4DED-AE29-DEC6C214B8EC'

  const mockData = {
    header: 'ขั้นที่ 2 ตรวจสอบข้อมูลผู้รับทุน',
    subHeader: 'ข้อเสนอโครงการ ปิดเทอมสร้างสรรค์ และกิจกรรมสร้างเสริมสุขภาพ สำหรับเด็กและ เยาวชน',
    forms: {
      granteeProfile: {
        granteeProfileHeader: 'ข้อมูลผู้ขอรับทุน',
        blacklistStatus: 'สถานะ Backlist',
        progressSummary: 'สรุปการดำเนินโครงการ',
        progressHistory: 'ประวัติดำเนินโครงการ',
        granteeStatus: false,
        granteeProfile: {
          granteeNameTitle: 'ชื่อผู้ขอรับทุนโครงการย่อย',
          granteeName: 'นาย วัลลภ บุญประเสริฐ',
          granteeNameTitleEN: 'ชื่อผู้ขอรับทุนโครงการย่อย (ภาษาอังกฤษ)',
          granteeNameEN: 'Mr. Wanlop Bunprasroet',
          departmentTitle: 'หน่วยงานสังกัด',
          department: 'สำนัก สสส.',
          addressTitle: 'ที่อยู่ที่สามารถติดต่อได้',
          address: 'สำนักงานคณะ อาคาร 8 ห้อง 812',
          telephoneTitle: 'โทรศัพท์',
          telephone: '0123456789',
          emailTitle: 'อีเมล',
          email: 'email@mail.com',
          checkValidity: 'การตรวจสอบความถูกต้อง',
          checkStatusTitle: 'สถานะตรวจสอบ',
          checkStatus: '',
          modifyDateTitle: 'ข้อมูลปรับปรุง เมื่อวันที่',
          modifyDate: '01 มกราคม 2564',
          checkCOIValidity: 'การตรวจสอบการมีส่วนได้ส่วนเสีย (COI)',
          checkCOIStatusTitle: 'สถานะตรวจสอบ',
          checkCOIStatus: '',
          modifyCOIDateTitle: 'ข้อมูลปรับปรุง เมื่อวันที่',
          modifyCOIDate: '01 มกราคม 2564',
        },
        blacklist: { statusTitle: 'สถานะ', status: 'ไม่ได้อยู่ในรายชื่อแบล็คลิส' },
        tableProjectSummary: {
          projectStatusTitle: 'สถานะโครงการ',
          quantityTitle: 'จำนวน',
          percentTitle: 'ร้อยละ',
          tableData: [
            { id: '63-0001', status: 'โครงการที่สำเร็จ', projectSummary: 10, summaryPercent: 55 },
            {
              id: '63-0002',
              status: 'โครงการที่ยกเลิก / ยุติ',
              projectSummary: 2,
              summaryPercent: 20,
            },
            {
              id: '63-0003',
              status: 'โครงการที่กำลังดำเนินการ',
              projectSummary: 3,
              summaryPercent: 25,
            },
            {
              id: '63-0004',
              status: 'โครงการที่รออนุมัติ / รอกลั่นกรอง',
              projectSummary: 4,
              summaryPercent: 15,
            },
            { id: '63-0004', status: 'โครงการที่ล่าช้า', projectSummary: 2, summaryPercent: 10 },
          ],
        },
        tableProjectHistory: {
          projectCodeTitle: 'รหัสโครงการ',
          projectNameTitle: 'ชื่อโครงการ',
          projectTypeTitle: 'ประเภทโครงการ',
          projectResultTitle: 'ผลพิจารณากลั่นกรอง',
          projectStausTitle: 'สถานะ',
          tableData: [
            {
              id: '63-0001',
              type: { icon: 'building2', label: 'แผนงาน' },
              projectName: 'สานต่อโครงการอารักข์ สร้างภูมิคุ้มกันตั้งแต่เยาว์วัย',
              colorstatus: { code: '1', label: 'อนุมัติ' },
              status: 'อนุมัติ',
              result: 'เห็นควร',
            },
            {
              id: '63-0002',
              type: { icon: 'copy-o', label: 'ชุดโครงการ' },
              projectName: 'เดินหน้าโครงการชุมชนจักรยานเพื่อสุขภาวะ ปี 3',
              colorstatus: { code: '2', label: 'สิ้นสุดโครงการ' },
              status: 'สิ้นสุดโครงการ',
              result: 'เห็นควร',
            },
            {
              id: '63-0003',
              type: { icon: 'file-o', label: 'โครงการ' },
              projectName: 'รร.พระยามนธาตุราชศรีพิจิตร์',
              colorstatus: { code: '2', label: 'สิ้นสุดโครงการ' },
              status: 'สิ้นสุดโครงการ',
              result: 'เห็นควร',
            },
            {
              id: '63-0004',
              type: { icon: 'file-o', label: 'โครงการ' },
              projectName: 'ประชุมโครงการพัฒนารูปแบบความร่วมมือเพื่อขับเคลื่อนสุขภาวะ',
              colorstatus: { code: '3', label: 'ยืนข้อเสนอ' },
              status: 'ยืนข้อเสนอ',
              result: 'ไม่เห็นควร',
            },
            {
              id: '63-0005',
              type: { icon: 'building2', label: 'แผนงาน' },
              projectName: 'ประชุมโครงการพัฒนารูปแบบความร่วมมือเพื่อขับเคลื่อนสุขภาวะ',
              colorstatus: { code: '4', label: 'กลั่นกรอง' },
              status: 'ทำสัญญา',
              result: 'เห็นควร',
            },
            {
              id: '63-0006',
              type: { icon: 'building2', label: 'แผนงาน' },
              projectName: 'ประกวดนวัตกรรม กาย จิต ปัญญา สังคม',
              colorstatus: { code: '6', label: 'ทำสัญญา' },
              status: 'ยืนข้อเสนอ',
              result: 'เห็นควร',
            },
          ],
        },
      },
    },
  }

  const handleGetSchema = async (projectId) => {
    setIsLoading(true)
    startLoading()

    try {
      const _schema = await getGranteeForStaffSubProject(projectId)
      // console.log('res => ', _schema)
      setSchema(_schema)
    } catch (e) {
      console.log(e)
    }

    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    console.log('load ObjectiveGoal proposal', projectId)
    projectId && handleGetSchema(projectId)
  }, [])

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      {schema && (
        <SidebarProposal isSubProject>
          <ContentHeader header={schema.header} subHeader={schema.subHeader} />

          <br />
          <GranteeProfileInfo schema={schema?.forms?.granteeProfile} />
        </SidebarProposal>
      )}
    </>
  )
}
